import script from "./CountriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./CountriesList.vue?vue&type=script&setup=true&lang=js"

import "./CountriesList.vue?vue&type=style&index=0&id=5697aed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5697aed6"]])

export default __exports__